export default "__VITE_ASSET__Ba2Bh945__"